<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:43:34
 * @Description: 编辑维保项目
-->
<template>
  <el-form
    ref="fd"
    v-loading="loading"
    :inline="true"
    label-suffix="："
    :model="fd"
    :rules="fdRules"
    label-position="right"
    label-width="150px"
    class="c-form u-pd-b-10"
  >
    <div class="o-tips u-mg-b-10">
      说明：修改维保内容时会更新本月之后的所有维保计划的维保内容，请完善维保计划。
    </div>
    <!-- 基本信息 -->
    <el-row class="c-form__row">
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        项目基础信息
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="重点单位"
          prop="zddw"
        >
          <el-radio-group
            v-model="fd.zddw"
            class="c-form__radio-group"
          >
            <el-radio label="Y">
              是
            </el-radio>
            <el-radio label="N">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="签到要求"
          prop="qdyq"
        >
          <el-radio-group
            v-model="fd.qdyq"
            class="c-form__radio-group"
          >
            <el-radio
              v-for="item in qdlxType"
              :key="item.id"
              :label="item.id"
            >
              {{ item.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="bgms"
          label="报告模式"
        >
          <el-radio-group
            v-model="fd.bgms"
            class="c-form__radio-group"
          >
            <el-radio
              v-for="item in bgmsType"
              :key="item.id"
              :label="item.id"
            >
              {{ item.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col> -->

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="企业名称"
          prop="wtdw"
        >
          <el-input
            v-model="fd.wtdw"
            class="c-form__input"
            type="text"
            placeholder="请输入企业名称"
          />
          <!-- <el-select
            v-model="fd.qymc"
            class="c-form__select"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in zdqyList"
              :key="item.qydm"
              :label="item.qymc"
              :value="item.qydm"
              @click.native="handleZdqyTyshxydm(item)"
            />
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="shxydm"
          label="统一社会信用代码"
        >
          <el-input
            v-model="fd.shxydm"
            class="c-form__input"
            type="text"
            placeholder="请输入统一社会信用代码"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目名称"
          prop="xmmc"
        >
          <el-input
            v-model="fd.xmmc"
            class="c-form__input"
            type="text"
            placeholder="请输入项目名称"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="所属区域"
          prop="areaDm"
        >
          <select-address
            v-model="fd.areaDm"
            required
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmdz"
          label="项目地址"
        >
          <el-input
            v-model="fd.xmdz"
            class="c-form__input"
            type="text"
            placeholder="请输入项目地址"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xfaqglr"
          label="消防安全管理人"
        >
          <el-input
            v-model="fd.xfaqglr"
            class="c-form__input"
            type="text"
            placeholder="请输入消防安全管理人"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="sjhm"
          label="手机号码"
        >
          <el-input
            v-model="fd.sjhm"
            class="c-form__input"
            type="text"
            placeholder="请输入手机号码"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="wygldw"
          label="物业管理单位"
        >
          <el-input
            v-model="fd.wygldw"
            class="c-form__input"
            type="text"
            placeholder="请输入物业管理单位"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          prop="fsdwxx"
          label="附属单位信息"
        >
          <el-input
            v-model="fd.fsdwxx"
            class="c-form__input"
            type="text"
            placeholder="请输入附属单位信息"
          />
          <!-- <el-select
            v-model="fd.fsdwxx"
            class="c-form__select"
            placeholder="请选择附属单位信息"
            clearable
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in fsdwxxList"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            />
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同名称"
          prop="htmc"
        >
          <el-input
            v-model="fd.htmc"
            class="c-form__input"
            autocomplete="off"
            maxlength="100"
            placeholder="请输入合同名称"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同编号"
          prop="htbh"
        >
          <el-input
            v-model="fd.htbh"
            class="c-form__input"
            autocomplete="off"
            maxlength="60"
            placeholder="请输入合同编号！"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同有效期"
          prop="htyxq"
        >
          <hm-date-range
            v-model="fd.htyxq"
            start-placeholder="合同有效期起"
            end-placeholder="合同有效期止"
            :clearable="true"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同金额（元）"
          prop="htje"
        >
          <el-input
            v-model="fd.htje"
            class="c-form__input"
            autocomplete="off"
            maxlength="60"
            placeholder="请输入合同金额"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="合同文件"
          prop="htfjId"
        >
          <file-serve-upload
            ref="fileUpload"
            v-model="fd.htfjId"
            class="u-inline-block"
            :file-api="$config.ctx.hmfileApi"
            show-file-list
            accept="application/pdf,application/msword,.doc,.docx"
            :data="uploadFd"
            :max-size="10 * 1024"
          >
            <k-button
              btn-text="上传"
              :auth-type="true"
              type="primary"
              icon="kestrel-icon ki-cloud-upload"
              plain
            />
            <span class="u-text-warning">（只能上传一份 doc / docx / pdf 文件，且不超过10M）</span>
          </file-serve-upload>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmgs"
          label="项目概况"
        >
          <el-input
            v-model="fd.xmgs"
            class="c-form__input"
            type="textarea"
            rows="4"
            placeholder="请输入项目概况"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        建筑信息
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzlbDm"
          label="建筑类别"
        >
          <el-select
            v-model="fd.jzlbDm"
            class="c-form__select"
            placeholder="请选择建筑类别"
            clearable
          >
            <el-option
              v-for="item in jzlbType"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zdxfsb"
          label="自动消防设备"
        >
          <el-radio-group
            v-model="fd.zdxfsb"
            class="c-form__radio-group"
          >
            <el-radio label="Y">
              有
            </el-radio>
            <el-radio label="N">
              无
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zzdmj"
          label="总占地面积（m²）"
        >
          <el-input
            v-model="fd.zzdmj"
            class="c-form__input"
            type="text"
            placeholder="请输入总占地面积"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zjzmj"
          label="总建筑面积（m²）"
        >
          <el-input
            v-model="fd.zjzmj"
            class="c-form__input"
            type="text"
            placeholder="请输入总建筑面积"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzlc"
          label="建筑层数"
        >
          <el-input
            v-model="fd.jzlc"
            class="c-form__input"
            type="text"
            placeholder="请输入建筑层数"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzgd"
          label="建筑高度（m）"
        >
          <el-input
            v-model="fd.jzgd"
            class="c-form__input"
            type="text"
            placeholder="请输入建筑高度"
          />
        </el-form-item>
      </el-col>

      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        维保信息
      </el-col>
      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="gdptzdts"
          label="广东平台自动推送"
        >
          <el-radio-group
            v-model="fd.gdptzdts"
            class="c-form__radio-group"
          >
            <el-radio label="Y">
              是
            </el-radio>
            <el-radio label="N">
              否
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmfzrDm"
          label="项目负责人"
        >
          <select-xm-user
            v-model="fd.xmfzrDm"
            role-code="FireEngineer"
            :show-dept="false"
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jsfzrDm"
          label="技术负责人"
        >
          <select-xm-user
            v-model="fd.jsfzrDm"
            role-code="FireEngineer"
            :show-dept="false"
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="wbnrList"
          label="维保内容"
        >
          <el-checkbox-group
            v-model="fd.wbnrList"
            class="c-form__checkbox-group"
          >
            <el-checkbox
              v-for="item in wbnrXtList"
              :key="item.wbnrId"
              class="dev-pDetail"
              :label="item.wbnrId"
            >
              {{ item.wbnrMc }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { wbxmService } from './wbxm.service.js';
import { xfwbglService } from '../xfwbgl.service';

export default {
  name: 'UpdateWbxm',
  data () {
    // 手机号码/固定电话检验
    const phoneValid = (rule, value, callback) => {
      const reg = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/;
      if (reg.test(value)) {
        callback();
      }
      callback(new Error('请检查手机号码格式是否正确'));
    };
    return {
      loading: false, // 页面loading状态
      qymc: '', // 重点企业名称
      zdqytyshxydm: '', // 重点企业社会信用代码
      showDialogName: '', // 弹框显示

      // zdqyList: [], // 重点企业列表
      fsdwxxList: [], // 附属单位信息列表
      stepNum: 0, // 当前维保步骤进度值

      /* 申请信息 Start */
      fd: {
        zddw: null, // 重点单位
        qdyq: '0', // 签到要求
        areaDm: null, // 所属区域
        wtdw: null, // 企业名称
        xmmc: null, // 项目名称
        xmdz: null, // 项目地址
        shxydm: null, // 统一社会信用代码【规则】
        xfaqglr: null, // 消防安全管理人
        sjhm: null, // 手机号码
        jzlbDm: null, // 建筑类别
        zdxfsb: null, // 自动消防设备
        zzdmj: null, // 总占地面积
        zjzmj: null, // 总建筑面积
        jzlc: null, // 建筑层数
        jzgd: null, // 建筑高度
        xmgs: null, // 项目概况
        bgms: '0', // 报告模式
        xmfzrDm: null, // 项目负责人
        jsfzrDm: null, // 技术负责人
        wygldw: null, // 物业管理单位
        gdptzdts: null, // 广东平台自动推送
        fsdwxx: null, // 附属单位信息
        wbnrList: [],
        htmc: null, // 合同名称
        htbh: null, // 合同编号
        htje: null, // 合同金额
        htfjId: null, // 合同附件
        htyxq: [], // 有效期
        htyxqQ: null,
        htyxqZ: null
      },
      wbnrXtList: null,
      /* 申请信息 End */

      /** 表单验证规则 Start */
      fdRules: {
        zddw: [this.$validUtils.required('重点单位')],
        bgms: [this.$validUtils.required('报告模式')],
        qdyq: [this.$validUtils.required('签到要求')],
        areaDm: [this.$validUtils.required('所属区域')],
        wtdw: [this.$validUtils.required('企业名称'), this.$HMValidator.maxLength('企业名称', 300)],
        xmmc: [this.$validUtils.required('项目名称'), this.$HMValidator.maxLength('项目名称', 300)],
        xmdz: [this.$validUtils.required('项目地址')],
        shxydm: [
          this.$validUtils.required('统一社会信用代码'),
          this.$HMValidator.tyshxydm('统一社会信用代码')
        ],
        xfaqglr: [this.$validUtils.required('消防安全管理人'), this.$HMValidator.maxLength('消防安全管理人', 50)],
        // sjhm: [this.$validUtils.required('手机号码')],
        sjhm: [this.$validUtils.required('手机号码'), { validator: phoneValid, trigger: 'change' }],
        jzlbDm: [this.$validUtils.required('建筑类别')],
        zdxfsb: [this.$validUtils.required('自动消防设施')],
        zzdmj: [
          this.$validUtils.required('总占地面积'),
          this.$validUtils.positiveNumber('总占地面积'),
          this.$HMValidator.money('总占地面积', 10, 2)
        ],
        zjzmj: [
          this.$validUtils.required('总建筑面积'),
          this.$validUtils.positiveNumber('总建筑面积'),
          this.$HMValidator.money('总建筑面积', 10, 2)
        ],
        jzlc: [
          this.$validUtils.required('建筑层数'),
          this.$HMValidator.number('建筑层数'),
          this.$HMValidator.money('建筑层数', 10)
        ],
        jzgd: [
          this.$validUtils.required('建筑高度'),
          this.$validUtils.positiveNumber('建筑高度'),
          this.$HMValidator.money('建筑高度', 10, 2)
        ],
        xmgs: [this.$validUtils.required('项目概况'), this.$HMValidator.maxLength('项目概况', 3000)],
        wbnrList: [this.$validUtils.required('维保内容')],
        htmc: [this.$validUtils.required('合同名称')],
        htje: [
          this.$validUtils.required('合同金额'),
          this.$HMValidator.money('合同金额', 16, 2)
        ],
        htyxq: [
          // 检验时间范围起不能晚于时间范围止
          this.$HMValidator.dateRange('合同有效期'),
          // 是否都必填（非必需校验）
          this.$HMValidator.dateRangeAllMust('合同有效期')
        ],
        htbh: [this.$validUtils.required('合同编号')],
        htfjId: [this.$validUtils.required('合同文件')],
        wygldw: [this.$HMValidator.maxLength('物业管理单位', 300)],
        fsdwxx: [this.$HMValidator.maxLength('附属单位信息', 300)]
      },
      /** 表单验证规则 End */

      /* 文件服务器对接参数 Start */
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'type',
            value: 'wbht'
          }
        ]
      }
      /* 文件服务器对接参数 End */
    };
  },
  computed: {
    /** 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_WB) {
        return enums.IFF_JZLB_WB;
      }
      return {};
    },
    /** 报告模式 */
    bgmsType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_BGMS) {
        return enums.IFF_BGMS;
      }
      return {};
    },
    /** 签到模式 */
    qdlxType () {
      // const enums = this.$store.state.apiEnums.iffApi;
      // if (enums && enums.IFF_QDLX) {
      //   return enums.IFF_QDLX;
      // }
      // return {};
      return [{
        id: '0',
        text: 'GPS签到'
      }];
    }
    /** 维保内容类型 */
    // wbnrType () {
    //   const enums = this.$store.state.apiEnums.iffApi;
    //   if (enums && enums.IFF_WBNRLX) {
    //     return enums.IFF_WBNRLX;
    //   }
    //   return {};
    // }
  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
    },
    /**
     * @description: 初始化维保项目信息
     * @return {*}
     * @param {*} khbm 维保项目编码
     */
    initWbxmInfo (xmId) {
      return wbxmService.getWbxmInfo(xmId)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.fd.htyxq = [this.fd.htyxqQ, this.fd.htyxqZ];

          // 维保内容信息处理
          this.fd.wbnrList = [];
          rsp.data.wbnrList.forEach(e => {
            this.fd.wbnrList.push(e.wbnrId);
          });

          // 重点企业判断
          // this.handleZdqyBz();
          this.$emit('handleWbxmInfo', rsp.data);
        })
        .catch(err => {
          console.error('初始化维保项目信息失败', err);
          Promise.reject(err);
        }).finally(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 获取重点企业列表
     * @return {*}
     */
    // getZdqyList () {
    //   const _this = this;
    //   xfwbglService.getZdqyList()
    //     .then(rsp => {
    //       _this.zdqyList = rsp.data;
    //     })
    //     .catch(err => {
    //       console.error('获取重点企业列表信息失败！', err);
    //     });
    // },

    /**
     * @description: 获取附属单位列表
     * @return {*}
     */
    getFsdwList () {
      xfwbglService.getFsdwList()
        .then(rsp => {
          this.fsdwxxList = rsp.data;
        })
        .catch(err => {
          console.error('获取附属单位列表信息失败！', err);
        });
    },
    /**
     * @description: 获取系统为内容列表
     * @return {*}
     */
    getXtWbnrList () {
      wbxmService.getXtWbnrList()
        .then(rsp => {
          this.wbnrXtList = rsp.data;
        })
        .catch(err => {
          console.error('获取系统维保内容列表信息失败！', err);
        });
    },

    /**
     * @description: 重点企业统一社会信用代码处理
     * @return {*}
     */
    handleZdqyTyshxydm (params) {
      const _this = this;
      _this.fd.shxydm = params.shxydm;
      _this.zdqytyshxydm = params.shxydm;
    },

    /**
     * @description: 重点企业标志变更处理
     * @return {*}
     */
    handleZdqyBz () {
      const _this = this;
      if (_this.fd.zddw === 'Y') {
        this.getZdqyList();
      } else {
        this.zdqyList = [];
      }
    },
    /**
     * @description: 获取维保进度步骤数
     * @return {*}
     */
    // getBzNum () {
    //   const _this = this;
    //   xfwbglService.getStepStatus()
    //     .then(rsp => {
    //       _this.stepNum = rsp.data.data;
    //     })
    //     .catch(err => {
    //       console.error('获取维保进度步骤信息失败！', err);
    //     });
    // },
    /**
     * @description: 界面初始化
     * @return {*}
     */
    async init () {
      // 获取附属单位列表
      // this.getFsdwList();
      // 获取步骤进度值
      // this.getBzNum();

      // 初始化维保项目信息
      await this.initWbxmInfo(this.fd.xmId);
    },

    /**
     * @description: 维保项目信息保存
     * @return {*}
     * @param {*} p
     */
    handleEdit () {
      const _this = this;
      [_this.fd.htyxqQ, _this.fd.htyxqZ] = _this.fd.htyxq;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;
          wbxmService.update(_this.fd)
            .then(rsp => {
              _this.$alert('保存成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
            })
            .catch(err => {
              console.error('维保项目保存出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }

  },
  created () {
    // 获取路由项目编码
    this.fd.xmId = this.$route.params.xmId;
    this.loading = true;
    this.init();
    this.getXtWbnrList();
  }

};
</script>

<style lang="scss">
.dev-c-page__footer--div {
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
</style>
